import axios from '@/axios/default'

export default {
  createSupportRequest (s) { return axios.post('/support', s) },
}
